import { Component, OnInit, Input, Output, EventEmitter, ViewChildren} from '@angular/core';

import * as moment from 'moment';

import { UtilService } from 'src/app/modules/shared/services/util.service';

interface IRange {
  value: Date[];
  label: string;
}

@Component({
  selector: 'app-report-filters',
  templateUrl: './report-filters.component.html',
  styleUrls: ['./report-filters.component.scss']
})
export class ReportFiltersComponent implements OnInit {

  @Input() page: string; // Used page
  @Input() showCalendar: boolean = true; // Show/hide date range
  @Input() showCouponSource: boolean = true; // Show/hide couponsource
  @Input() showCouponSourceRetailer: boolean = true; // Show/hide 'retailer' coupon source
   @Input() showCouponStatus: boolean = true; // Show/hide coupon status (expired/active/upcoming)
  @Output() filterChange = new EventEmitter(); // Filer change event

  public loginData: any;
  public stores: any = [];
  public selectedStore: any = 0;

  public calendarRanges: IRange[];
  public calendarConfig;
  public calendarMinDate: Date;
  public calendarMaxDate: Date;
  public dateRange: any = [];
  
  public couponSource: string; // national/cpg/retailer
  public couponStatus: string // expired/active/upcoming

  constructor(
    private _utilService: UtilService
  ) {}

  ngOnInit(): void {
    this.getStorageData();
  }

  async getStorageData() {
    this.loginData = await this._utilService.getStorageData('R_LOGIN');
    this.stores = await this._utilService.getStorageData('R_RETAILERS');

    // Calendar setings with timezone
    this.calendarRanges = [
      { value: [new Date(new Date().setDate(new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm')).getDate() - 0)), new Date(new Date().setDate(new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm')).getDate() - 0))],  label: 'Today'},
      { value: [new Date(new Date().setDate(new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm')).getDate() - 1)), new Date(new Date().setDate(new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm')).getDate() - 1))],  label: 'Yesterday'},
      { value: [new Date(new Date().setDate(new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm')).getDate() - 6)), new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm'))],  label: 'Last 7 Days'},
      { value: [new Date(new Date().setDate(new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm')).getDate() - 29)), new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm'))],  label: 'Last 30 Days'},
    ];
    this.calendarConfig = { adaptivePosition: true, dateInputFormat: 'YYYY-MM-DD HH:mm', containerClass: 'theme-blue', showWeekNumbers: false, ranges: this.calendarRanges };
    this.calendarMinDate = new Date(moment().utcOffset(this.loginData.user_details.user_timezone).subtract(3, 'years').format('YYYY-MM-DD HH:mm'));
    this.calendarMaxDate = new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm'));
    
    if (!this.selectedStore) { // Set first store as default
      // Set default filters
      this.selectedStore = this.stores[0].store_id;
      if (this.showCouponSourceRetailer == true)  {
        this.couponSource = 'retailer';
      } else {
        if (this.page == 'regional-coupon-payments') {
          this.couponSource = 'cpg';
        } else if (this.page == 'national-coupon-payments') {
          this.couponSource = 'national';
        } else {
          this.couponSource = 'cpg';
        }
      }
      this.couponStatus = 'active'; 

      // Send data to parent component if calandar is hiden
      if (!this.showCalendar) {
        this.filterChange.emit({ change: 'store', store: +this.selectedStore, date_range: this.dateRange, coupon_source: this.couponSource, coupon_status: this.couponStatus});
      } else { // Set calendar default date as today
        this.dateRange = [new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm')), new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm'))];
      }
    }
  }

  // Store change
  onStoreChange(event: any) {
    if (!this.showCalendar) { // Calandar is hiden
      if (this.selectedStore && this.couponSource) {
        this.filterChange.emit({ change: 'store', store: +this.selectedStore, date_range: this.dateRange, coupon_source: this.couponSource, coupon_status: this.couponStatus});
      }
    } else { // Calandar is visible
      if (this.selectedStore && this.dateRange.length == 2 && this.couponSource) {
        this.filterChange.emit({ change: 'store', store: +this.selectedStore, date_range: this.dateRange, coupon_source: this.couponSource, coupon_status: this.couponStatus});
      }
    }
  }

  // On calendar value change
  onCalendarValueChange(event: any) {
    this.dateRange = event;

    if (this.selectedStore && this.dateRange.length == 2 && this.couponSource) {
      this.filterChange.emit({ change: 'date_range', store: +this.selectedStore, date_range: this.dateRange, coupon_source: this.couponSource, coupon_status: this.couponStatus});
    }
  }

  // Coupon source change
  oncouponSourceChange(source: string){
    this.couponSource = source;

    if (!this.showCalendar) { // Calandar is hiden
      if (this.selectedStore && this.couponSource) {
        this.filterChange.emit({ change: 'coupon_source', store: +this.selectedStore, date_range: this.dateRange, coupon_source: this.couponSource, coupon_status: this.couponStatus});
      }
    } else { // Calandar is visible
      if (this.selectedStore && this.dateRange.length == 2 && this.couponSource) {
        this.filterChange.emit({ change: 'coupon_source', store: +this.selectedStore, date_range: this.dateRange, coupon_source: this.couponSource, coupon_status: this.couponStatus});
      }
    }
  }

  // Coupon status change
  oncouponStatusChange(status: string){
    this.couponStatus = status;

    if (!this.showCalendar) { // Calandar is hiden
      if (this.selectedStore && this.couponStatus) {
        this.filterChange.emit({ change: 'coupon_status', store: +this.selectedStore, date_range: this.dateRange, coupon_source: this.couponSource, coupon_status: this.couponStatus});
      }
    } else { // Calandar is visible
      if (this.selectedStore && this.dateRange.length == 2 && this.couponStatus) {
        this.filterChange.emit({ change: 'coupon_status', store: +this.selectedStore, date_range: this.dateRange, coupon_source: this.couponSource, coupon_status: this.couponStatus});
      }
    }
  }

}
